import * as React from 'react';
import { Redirect } from 'react-router-dom';
import {
  CipReportWrapper,
  Content,
  BoxWrapper
} from './styled';

import { SidebarFeature } from '@app/src/commons/sidebar';
import { ListFeature } from '@app/src/views/CipReport/list';
import { FilterFeature } from '@app/src/views/CipReport/filter';
import { useAuthorization } from '@app/src/utils/validations';
import { HeaderFeature } from '@app/src/commons/header';

export const CipReport = ({ history }) => {

  const isValid = useAuthorization();

  return (
    <>
      {isValid ?
        (<CipReportWrapper>
          <SidebarFeature history={history} />
          <Content>
            <BoxWrapper>
              <HeaderFeature subTitle="Reportes CallCenter" />
              <FilterFeature url={process.env.API_CIPS} />
              <ListFeature url={process.env.API_CIPS} />
            </BoxWrapper>
          </Content>
        </CipReportWrapper>) : <Redirect to="/" />
      }
    </>
  );
};
